/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file_circle': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zM101 44.094c0-.555-.219-1.089-.61-1.482A2.08 2.08 0 0 0 98.918 42H53.083A2.088 2.088 0 0 0 51 44.094v62.812c0 .555.219 1.089.61 1.482.39.392.921.612 1.473.612h33.334a2.073 2.073 0 0 0 1.58-.733l12.5-14.656a2.04 2.04 0 0 0 .342-.581c.026-.066.036-.134.057-.21h.002c.045-.151.07-.306.081-.46 0-.04.021-.079.021-.118V44.094zm-45.833 2.093h41.666v43.97H86.417a2.088 2.088 0 0 0-2.084 2.093v12.562H55.167V46.187zM88.5 94.344h5.888l-5.888 6.909v-6.91zM61 55v4h29v-4H61zm0 8v4h29v-4H61zm0 8v4h29v-4H61zm0 9v4h19v-4H61z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
